import React, {Component} from "react";
import './checkboxCustom.css'

class CheckboxCustom extends Component{
    render(){
        return (
            <label className={'checkbox-custom checkcontainer'}>
                <input name={this.props.name}
                       value={this.props.value}
                       type={'radio'}
                       onChange={this.props.onChange}
                       checked={this.props.checked}
                />
                <span className={'radiobtn'}></span>
                <p className={'description-card-type'}>{this.props.text}</p>
            </label>
        );
    }
}

CheckboxCustom.defaultProps = {
    onChange: ()=>{},
    checked: false,
    value: '',
};

export default CheckboxCustom;